import {isOnGalleryDiscussionView} from '../../util/urls';
import * as Urls from '../../util/urls';

export function getDraftUrl({
  parentId,
  draftId,
  draftDisplayName,
  entityName,
  projectName,
}: {
  parentId: string;
  draftId: string;
  draftDisplayName: string;
  entityName: string;
  projectName?: string;
}) {
  if (projectName == null) {
    return (
      isOnGalleryDiscussionView()
        ? Urls.galleryDiscussionEdit
        : Urls.galleryPostEdit
    )({
      entityName,
      reportID: draftId,
      reportName: draftDisplayName,
    });
  }

  return Urls.reportEdit(
    {
      entityName,
      projectName,
      reportID: parentId,
      reportName: draftDisplayName,
    },
    '?draftId=' + draftId
  );
}
